import { forwardRef, type ComponentProps } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const textareaVariants = tv({
	base: 'appearance-none w-full py-2 px-3 text-base outline-none border-none shadow-none bg-dm-white text-black hover:border-none focus:border-none placeholder:text-dm-strong-mid-grey',
	variants: {
		hasError: {
			true: 'border-red-600 bg-red-100'
		},
		disabled: {
			true: 'cursor-not-allowed bg-gray-200 opacity-50'
		},
		size: {
			md: 'h-20',
			lg: 'h-32'
		},
		fullWidth: {
			true: 'w-full',
			false: 'w-auto'
		},
		rounded: {
			sm: 'rounded-sm',
			md: 'rounded-md',
			lg: 'rounded-lg'
		},
		resize: {
			true: 'resize',
			false: 'resize-none'
		}
	},
	defaultVariants: {
		size: 'md',
		fullWidth: true,
		rounded: 'md',
		resize: false
	}
});

export type TextareaProps = ComponentProps<'textarea'> &
	VariantProps<typeof textareaVariants>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
	(
		{
			className,
			size,
			rounded,
			fullWidth,
			hasError,
			disabled,
			resize,
			...props
		},
		ref
	) => {
		return (
			<textarea
				{...props}
				ref={ref}
				disabled={disabled}
				className={textareaVariants({
					size,
					rounded,
					fullWidth,
					hasError,
					disabled,
					resize,
					className
				})}
			/>
		);
	}
);

Textarea.displayName = 'Textarea';
